import _ from 'lodash';
import { Paginator } from '@/core/Paginator.molecule';
import { MIN_HOME_SCREEN_ITEM_COUNT } from '@/homescreen/homescreen.constants';

export type PaginationAndFilteringSupportingData = {
  itemTotalForTable: number;
  pageSize: number;
  pageNumber: number;
  searchParams: object;
  sortProperty?: string | null;
  sortAscending?: boolean | null;
};

export type LoadTableFunction = (offset: number, limit: number, searchParams?: object) => void;

export type PaginationAndFilteringSupportingActions = {
  setPageSizeForTable: ({ size, table }: { size: number; table?: string }) => void;
  setPageNumberAndGo: (page: number, loadTable: LoadTableFunction, table?: string, searchParams?: object) => void;
};

interface PaginationProps extends PaginationAndFilteringSupportingData {
  loadTable: LoadTableFunction;
  actions: PaginationAndFilteringSupportingActions;
  tableType?: string;
  insideModal?: boolean;
}

export const Pagination = ({
  itemTotalForTable: totalResults,
  pageSize: tablePageSize,
  pageNumber,
  searchParams,
  actions,
  tableType,
  loadTable,
  insideModal,
}: PaginationProps) => {
  const pageCount = _.max([Math.ceil(totalResults / tablePageSize), 1]) as number;

  const setPageSizeInStoreAndTable = (size: number) => {
    actions.setPageSizeForTable({ size, table: tableType });
    actions.setPageNumberAndGo(1, loadTable, tableType, searchParams);
  };

  return totalResults > MIN_HOME_SCREEN_ITEM_COUNT ? (
    <Paginator
      gotoPage={(number) => actions.setPageNumberAndGo(number, loadTable, tableType, searchParams)}
      pageCount={pageCount}
      pageNumber={pageNumber}
      pageSize={tablePageSize}
      insideModal={insideModal}
      setPageSize={setPageSizeInStoreAndTable}
    />
  ) : null;
};

export default Pagination;
